// Nested reducers
import { catalogManagementReducer } from "./catalog-management/catalog-management.reducer";
import { contractManagementReducer } from "./contract-management/contract-management.reducer";
import { contractReportsReducer } from "./contract-reports/contract-reports.reducer";
import { catalogDatasetsReducer } from "./catalog-datasets/catalog-datasets.reducer";

// **************************************************************************
// CONTRACT ADMIN REDUCER
// Note: Contracts and Catalogs LIST DATA is managed by entities stores
// This reducer handles admin-specific CRUD loading states
// **************************************************************************

export const contractAdminReducer = [
    ...catalogManagementReducer,
    ...contractManagementReducer,
    ...contractReportsReducer,
    ...catalogDatasetsReducer,
];
